import { RefObject, useEffect } from "react";

/**
 * Слушает глобальный pointerdown и вызывает onOutside, когда тык произошёл
 * за пределами контейнера. Нужен, чтобы снимать selection с overlay'а при
 * клике вне превью.
 */
export const useDeselectOnOutsideClick = (
  containerRef: RefObject<HTMLElement | null>,
  onOutside: () => void,
) => {
  useEffect(() => {
    const handler = (e: PointerEvent) => {
      const container = containerRef.current;
      if (!container) return;
      if (!container.contains(e.target as Node)) onOutside();
    };
    document.addEventListener("pointerdown", handler);
    return () => document.removeEventListener("pointerdown", handler);
  }, [containerRef, onOutside]);
};
